<template>
  <el-dialog
    :visible="show"
    append-to-body
    width="500px"
    title="折线详细数据"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <el-form ref="vForm" label-width="120px" :model="vForm">
      <el-form-item label="名称" prop="name" :rules="{ required: true, message: '名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>

      <el-form-item
        label="线条宽度"
        prop="width"
        :rules="{ required: true, message: '线条宽度必填' }"
      >
        <el-input v-model="vForm.width"></el-input>
      </el-form-item>

      <el-form-item
        label="线条颜色"
        prop="color"
        :rules="{ required: true, message: '线条颜色必填' }"
      >
        <el-color-picker v-model="vForm.color"></el-color-picker>
      </el-form-item>
      <el-form-item v-if="isArrowLine" label="两端箭头" prop="color">
        <el-switch v-model="vForm.arrow" :active-value="1" :inactive-value="2"> </el-switch>
      </el-form-item>
      <el-form-item  label="虚线" prop="color">
        <el-switch v-model="vForm.dotted" :active-value="1" :inactive-value="2"> </el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button type="primary" size="small" @click="doSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isArrowLine: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      vForm: {
        name: '',
        color: '#f00f00',
        width: 2,
        isLine: this.isArrowLine,
        arrow: 1,
        dotted: 2,
      },
    };
  },

  methods: {
    //关闭弹窗
    closeDialog() {
      this.$emit('update:show', false);
    },

    //确认添加热点图标
    async doSubmit() {
      try {
        await this.$refs.vForm.validate();
        this.$emit('success', this.vForm);
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.default-box {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 10px;
}

.default-img-list {
  display: flex;
  align-items: center;
}

.default-img {
  display: block;
  width: 30px;
  height: 30px;
  background: #ccc;
  margin-left: 5px;
  cursor: pointer;
}

.select-vr {
  position: relative;
}

.select-vr-control {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.form-item-multiple > .el-form-item__content {
  display: flex;
  align-items: flex-start;
}

.form-item-multiple > .el-form-item__content .el-form-item {
  flex: 1;
}

.form-item-multiple > .el-form-item__content .el-form-item:first-child {
  margin-right: 3px;
}

.form-item-multiple > .el-form-item__content .el-form-item:last-child {
  margin-left: 3px;
}

.url-select {
  position: relative;
  display: flex;
  align-items: center;
}

.url-select-clear {
  position: absolute;
  top: 0;
  right: 100px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
}

.url-select-in >>> .el-input__inner {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.url-select-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.select-video-btn {
  position: absolute;
  height: 40px;
  width: 100px;
  right: 0;
  top: 0;
  overflow: hidden;
  opacity: 0;
}

.video-control {
  flex: 1;
  position: relative;
}

.video-progress {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
</style>
